<div
  class="item-card"
  [class.clickable]="clickable"
  [class.variant-red]="variant === 'red'"
  [class.variant-green]="variant === 'green'"
  [attr.role]="clickable ? 'button' : null"
  [attr.tabindex]="clickable ? 0 : null"
  (click)="onClick()"
  (keydown.enter)="onClick()"
>
  <div class="card-icon-wrap">
    <grid-icon name="document-text-outline" size="m"></grid-icon>
  </div>

  <div class="card-body">
    <span class="card-label" *ngIf="label">{{ label }}</span>
    <span class="card-value">{{ value }}</span>
  </div>

  <div class="card-action" *ngIf="clickable && actionIconName">
    <grid-icon [name]="actionIconName" size="m"></grid-icon>
    <span *ngIf="actionLabel">{{ actionLabel }}</span>
  </div>
</div>
